<template>
  <template v-if="ShowVet">
    <AccountVet :key="$route.fullPath" />
  </template>
  <template v-else-if="ShowDelegue">
    <AccountDelegue :key="$route.fullPath" />
  </template>
  <template v-else>
    <AccountClient :key="$route.fullPath" />
  </template>
</template>

<script>
  import AccountVet from "@/views/supplyvet/MyAccountVet.vue"; // Page account supplyvet
  import AccountClient from "@/views/e-supplyvet/MyAccountClient.vue"; // Page account client supplyvet
  import AccountDelegue from "@/views/supplyvet/AccountDelegue.vue"; // Page account delegue
  import { useRegisterStore } from "@/stores/register";

  export default {
    name: "HomePage",
    components: {
      AccountVet,
      AccountClient,
      AccountDelegue
    },
    data() {
      return {
        ShowVet: false,
        ShowDelegue: false,
      };
    },
     created() {
    this.registerStore = useRegisterStore();
    if (this.registerStore.user) {
      this.ShowVet = this.registerStore.user.role === "veterinaire";
      this.ShowDelegue = this.registerStore.user.role === "delegues";
    }
  },
  };
</script>
